import { Country } from '@tradingblock/types';
export var isForeignAccount = function isForeignAccount(primaryAccountHolderAddressCountryCode) {
  return primaryAccountHolderAddressCountryCode !== Country.UnitedStatesOfAmerica;
};